import { Text, theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';
import { rem } from '@prose-ui/utils/units';

import { ImageAndTextOverlay } from 'Components/ImageAndTextOverlay';
import { Typography } from 'Components/Typography';

import { fiveStarProductReviewsContent } from 'assets/content/homeV2';

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
`;

const TitleContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  width: 274px;
  ${legacyTheme.breakpoints.up('md')} {
    width: 100%;
  }
`;

const StyledTitle = styled(Typography)`
  font-family: ${theme.typography.fontFamily.body};
  font-size: ${rem(1.5)};
  ${legacyTheme.breakpoints.up('md')} {
    font-size: ${rem(2.5)};
  }
`;

export const FiveStarProductReviews = () => {
  const { title, imgAlt, imgMobile, imgDesktop, disclaimer } = fiveStarProductReviewsContent;

  return (
    <ImageAndTextOverlay dataTestId="5-star-image" imgData={{ imgDesktop, imgMobile, imgAlt }}>
      <Container>
        <TitleContainer>
          <StyledTitle align="center" color="white" markupName="h2">
            {title}
          </StyledTitle>
        </TitleContainer>
        <Text align="center" color="neutral.100" paddingBottom="3x" variant="bodySm">
          {disclaimer}
        </Text>
      </Container>
    </ImageAndTextOverlay>
  );
};
